import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { PATTERN_ALPHA_NUMERIC_WITH_SPACE } from "src/app/utils/constant";
import { BranchMaintenanceService } from "../branch-maintenance.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { of as observableOf } from 'rxjs';
import { finalize } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: 'esc-branch-maintenance-form',
  templateUrl: './branch-maintenance-form.component.html',
  styleUrls: ['./branch-maintenance-form.component.scss']
})
export class BranchMaintenanceFormComponent implements OnInit {
  @Input() detail;
  @Input() mode;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  public isDisabled;
  loading = {
    submit: false
  };
  chainRequired;
  cityRequired;

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    public branchMntSvc: BranchMaintenanceService
  ) {}

  public formGroup: FormGroup;

  ngOnInit() {
    this.initForm();
    // console.log(this.detail);
  }

  initForm() {
    this.formGroup = this.fb.group({
      code: [_.get(this.detail, "code"), [Validators.required, Validators.maxLength(20), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      description: [_.get(this.detail, "description"), [Validators.required, Validators.maxLength(50), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],
      
      chain: [_.get(this.detail, "chain"), [Validators.required]],

      country: [_.get(this.detail, "country")],

      region: [_.get(this.detail, "region")],

      province: [_.get(this.detail, "province")],

      city: [_.get(this.detail, "city"), [Validators.required]],

      status: _.get(this.detail, "is_active") == 1 ? true : false
    });

    this.toggleDisable(null);
  }

  toggleDisable(data) {
    if (!this.detail) {
      this.formGroup.get("status").disable({ emitEvent: false });
      this.formGroup.get("status").setValue(true);
    } 
    else if (_.has(data, 'id')) {
      this.formGroup.get("code").disable({ emitEvent: false });
    }
  }

  chainSelected(ev) {
    this.formGroup.get('chain').setValue(ev);
    this.formGroup.get('chain').markAsTouched();
  }

  citySelected(ev) {
    let temp = _.cloneDeep(this.detail) || {};
    this.detail = null;

    this.formGroup.get('country').setValue(_.get(ev, 'country'));
    temp.country = _.get(ev, 'country');

    this.formGroup.get('region').setValue(_.get(ev, 'region'));
    temp.region = _.get(ev, 'region');

    this.formGroup.get('province').setValue(_.get(ev, 'province'));
    temp.province = _.get(ev, 'province');

    this.formGroup.get('city').setValue(ev);
    this.formGroup.get('city').markAsTouched();
    this.detail =_.cloneDeep(temp);
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();
    this.isDisabled = true;

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          code: _.toUpper(_.get(this.formGroup.get("code"), "value")),

          description: _.toUpper(_.get(this.formGroup.get("description"), "value")),

          chain_id: _.toInteger(_.get(this.formGroup.get("chain"), "value.id") || 1),

          city_id: _.toInteger(_.get(this.formGroup.get("city"), "value.id") || 1),

          is_active: is_active
        }
      ]
    };

    this.saving.emit(true);

    this.branchMntSvc.insert(obj).pipe(
      finalize(() => {
        this.loading.submit = false;
        this.saving.emit(false);
        this.formGroup.enable();
        this.toggleDisable(obj);
        this.isDisabled = false;
        return observableOf(null);
      }))
      .subscribe(
        (res: any) => {
          if (environment.showLogs) {
            console.log(res);
          }

          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;

          if (_.get(res, 'success.count') > 0) {
            //the ff needs to be an obj to display detail correctly
            obj.data[0]["chain"] = _.get(this.formGroup.get("chain"), "value");
            obj.data[0]["country"] = _.get(this.formGroup.get("country"), "value");
            obj.data[0]["region"] = _.get(this.formGroup.get("region"), "value");
            obj.data[0]["province"] = _.get(this.formGroup.get("province"), "value");
            obj.data[0]["city"] = _.get(this.formGroup.get("city"), "value");

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }

  close(data) {
    this.closeForm.next(data);
  }
}